import { createRouter, createWebHistory } from "vue-router";
//import persistentData from '@/plugins/persistentData';
import UploadFile from "@/plugins/UploadFileCDN.vue";
import Login from '@/views/Login.vue';
import SSO from '@/views/SSO.vue';
import Profile from '@/views/Profile.vue';
import PickRole from '@/views/PickRole.vue';
import RecoveryPassword from '@/views/RecoveryPassword.vue';
import Home from '@/views/Home.vue';
import MyCourses from '@/views/MyCourses.vue';
import Resources from '@/views/Resources.vue';
import Course from '@/views/Course.vue';
import Module from '@/views/Module.vue';
import NotAllowed from '@/views/NotAllowedError.vue';
import CustomLinks from '@/views/CustomLinks.vue';
import CourseEnd from '@/views/CourseEnd.vue';
/* Activities */
import Forum from '@/views/Forum/Forum.vue';
import ForumHeaders from '@/views/Forum/SelectHeader.vue';
import Attach from '@/views/Activity/Attach.vue';
import ModuleMuro from "@/views/Activity/module-muro.vue";
/* TUTOR */
import AttachUserHistory from '@/views/Activity/AttachUserHistory.vue';
import MuroUserHistory from '@/views/Activity/MuroUserHistory.vue';
import ForumUserHistory from '@/views/Forum/ForumUserHistory.vue';
import TutorCourseReport from '@/views/TutorCourseReport.vue';
/* CARGADOR DE RECURSOS*/
import CargadorRecursos from "@/views/Cargador-recursos.vue";
/* MURO */
import Muro from '@/views/Muro.vue';
import finalPractice from '@/views/FinalPractice.vue';
/* Inscription */
import CreatePreinscription from '@/views/Inscription/CreatePreinscription.vue';
import Preinscription from '@/views/Inscription/Preinscription.vue';
import CreateCourses from '@/views/Inscription/CreateCourses.vue';
/* Inscription -> Management */
import Management from '@/views/Inscription/Management/Main.vue'; //Vista padre para cursos y preinscripciones
import Preinscriptions from '@/views/Inscription/Management/Preinscriptions.vue';
import Courses from '@/views/Inscription/Management/Courses.vue';
import Links from '@/views/Inscription/Management/Links.vue';
import ManagementCourse from "@/views/Inscription/Management/Course.vue";
import ManagementUsers from "@/views/Inscription/Management/Users.vue";
//import Course_management from '@/views/Management/Course.vue';
import ContentShare from "@/views/ContentShare.vue";

/* Contents */
import ContentsMain from '@/views/Contents/Main.vue'
import MasterCourses from "@/views/Contents/MasterCourses.vue";
import ConfigurationMasterCourses from "@/views/Contents/MastersCourses/ConfigurationMasterCourses.vue";
import InformationMasterCourses from "@/views/Contents/MastersCourses/InformationMasterCourses.vue";
import CourseStructure from "@/views/Contents/MastersCourses/CourseStructure.vue";
import Main from "@/views/Contents/MastersCourses/Main.vue";
import Certificate from "@/views/Contents/MastersCourses/Certificate.vue";
import ModuleEditor from "@/views/Contents/ModuleEditor.vue";
import Review from "@/views/Contents/MastersCourses/Review.vue";

/* StudentsActivityLog */
import TableStudents from "@/views/StudentsActivityLog/TableStudents.vue"
import ActivityLog from "@/views/StudentsActivityLog/TableLogs.vue"



/* const guard = (to, from, next) => {
  if (persistentData.get('token') !== null) {
    next()
  } else {
    next('/login')
  }
} */

const routes = [
  {
    path: "/uploadfile",
    name: "UPLOAD_FILE",
    component: UploadFile,
  },
  {
    path: "/login",
    name: "LOGIN",
    component: Login,
  },
  {
    path: "/SSO",
    name: "SSO",
    component: SSO,
  },
  {
    path: "/pickRole",
    name: "PICKROLE",
    component: PickRole,
  },
  {
    path: "/recoveryPassword",
    name: "RECOVERY-PASSWORD",
    component: RecoveryPassword,
  },
  {
    path: "/",
    name: "HOME",
    component: Home,
    //beforeEnter: guard
  },
  {
    path: "/profile",
    name: "PROFILE",
    component: Profile,
  },
  {
    path: "/my-courses",
    name: "MY-COURSES",
    component: MyCourses,
  },
  {
    path: "/resources",
    name: "RESOURCES",
    component: Resources,
  },
  {
    path: "/resources/:resourceId",
    name: "RESOURCE",
    component: Resources,
  },
  {
    path: "/course/:courseId",
    component: Course,
    name: "COURSE",
    children: [
      {
        path: "module/:moduleId",
        component: Module,
        name: "COURSE_MODULE",
      },
      {
        path: "module/:moduleId/muro/:muroId",
        component: ModuleMuro,
        name: "COURSE_MODULE_MURO",
      },
      {
        path: "module/:moduleId/muro/:contentId/userHistory/:userId",
        component: MuroUserHistory,
        name: "COURSE_MURO_USER_HISTORY",
      },
      {
        path: "module/:moduleId/activity/attach/:contentId",
        component: Attach,
        name: "COURSE_ATTACH",
      },
      {
        path: "module/:moduleId/activity/attach/:contentId/userHistory/:userId",
        component: AttachUserHistory,
        name: "COURSE_ATTACH_USER_HISTORY",
      },
      {
        path: "module/:moduleId/forum/:contentId",
        component: ForumHeaders,
        name: "COURSE_FORUM_HEADERS",
      },
      {
        path: "module/:moduleId/forum/:contentId/:headerId",
        component: Forum,
        name: "COURSE_FORUM",
      },
      {
        path: "module/:moduleId/forum/:contentId/userHistory/:userId",
        component: ForumUserHistory,
        name: "COURSE_FORUM_USER_HISTORY",
      },
      {
        path: "board",
        component: Muro,
        name: "COURSE_BOARD",
      },
      {
        path: "finalPractice",
        component: finalPractice,
        name: "COURSE_FINAL_PRACTICE",
      },
      {
        path: "studentsActivityLog",
        component: TableStudents,
        name: "COURSE_STUDENTS_LOG",
      },
      {
        path: "courseEnd",
        component: CourseEnd,
        name: "COURSE_COURSE_END",
      }
    ],
  },
  {
    path: "/course/:courseId/report",
    component: TutorCourseReport,
    name: "TUTOR_COURSE_REPORT",
  },
  {
    path: "/notAllowed",
    component: NotAllowed,
    name: "NOT_ALLOWED",
  },
  {
    path: "/51D982C1-00AB-4D1B-B276-A0CDF1BDEDA2",
    component: CargadorRecursos,
    name: "EL_CARGADOR_SUPREMO",
  },
  {
    path: "/createPreinscription",
    component: CreatePreinscription,
    name: "CREATE_PREINSCRIPTION",
  },
  {
    path: "/editPreinscription/:id",
    component: CreatePreinscription,
    name: "EDIT_PREINSCRIPTION",
  },
  {
    path: "/preInscription/:preInscriptionId",
    component: Preinscription,
    name: "PRE_INSCRIPTION",
    children: [
      {
        path: ":stageId",
        component: Preinscription,
        name: "PRE_INSCRIPTION_STAGE",
      },
    ],
  },
  {
    path: "/createCourses",
    component: CreateCourses,
    name: "CREATE_COURSES",
    children: [
      {
        path: ":preinscriptionId",
        component: CreateCourses,
        name: "CREATE_COURSES",
      },
    ],
  },
  {
    path: "/management",
    component: Management,
    name: "MANAGEMENT",
    children: [
      {
        path: "courses",
        component: Courses,
        name: "MANAGEMENT_COURSES",
      },
      {
        path: "courses/participants/:courseId",
        component: ManagementCourse,
        name: "MANAGEMENT_COURSE",
      },
      {
        path: "courses/users/:courseid",
        component: ManagementUsers,
        name: "MANAGEMENT_COURSE_USERS",
      },
      {
        path: "preinscriptions",
        component: Preinscriptions,
        name: "MANAGEMENT_PREINSCRIPTIONS",
      },
      {
        path: "links",
        component: Links,
        name: "MANAGEMENT_LINKS",
      },        
    ],
  },
  {
    path: "/contents",
    component: ContentsMain,
    name: "CONTENTS",
    children: [
      {
        path: "mastercourses",
        component: MasterCourses,
        name: "MASTERCOURSES",
      },
    ],
  },
  {
    path: "/contents/mastercourses/:courseCfgId",
    component: Main,
    name: "EDITCOPYCOUSEMAIN",
    children: [
      {
        path: "copy",
        component: ConfigurationMasterCourses,
        name: "ConfigurationMasterCoursesCopy",
      },
      {
        path: "edit",
        component: ConfigurationMasterCourses,
        name: "ConfigurationMasterCoursesEdit",
      },
      {
        path: "information",
        component: InformationMasterCourses,
        name: "InformationMasterCourses",
      },
      {
        path: "structure",
        component: CourseStructure,
        name: "COURSESTRUCTURE",
      },
      {
        path: "moduleEditor/:moduleId",
        component: ModuleEditor,
        name: "COURSESTRUCTURE_MODULE_EDITOR",
      },
      {
        path: "certificate",
        component: Certificate,
        name: "COURSESTRUCTURE_CERTIFICATE",
      },
      {
        path: "review",
        component: Review,
        name: "COURSESTRUCTURE_REVIEW",
      },
    ],
  },
  {
    path: "/contentShare/:id",
    component: ContentShare,
    name: "ContentShare",
  },
  {
    path: "/interactions/:studentId",
    component: ActivityLog,
    name: "ActivityLog",
  },
  {
    path: "/on-demand",
    component: CustomLinks,
    name: "onDemand",
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    window.scrollTo(0, 0);
  },
});

export default router;
